"use client";

import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";

import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu";
import { THEMES } from "@/config/themes";

/**
 * Theme submenu for a dropdown. Menu content only mounts once it's opened on the
 * client, so reading the theme here can't cause a hydration mismatch.
 */
export function ThemeMenuSub() {
  const { theme, setTheme } = useTheme();
  const t = useTranslations();
  const current = THEMES.find((t) => t.value === theme) ?? THEMES[2];

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <current.icon aria-hidden />
        {t("shell.theme")}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuRadioGroup value={current.value} onValueChange={setTheme}>
          {THEMES.map(({ value, icon: Icon }) => (
            <DropdownMenuRadioItem key={value} value={value}>
              <Icon aria-hidden />
              {t(`themes.${value}`)}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
